import React from 'react';
import PropTypes from 'prop-types';
import { FieldSimple, constants, SpacerVertical, ButtonPrimary } from '@klarna/bubble-ui';
import { withRouter } from 'react-router-dom';

const containerStyle = {
  position: 'fixed',
  top: 300,
  right: 50,
  width: 250,
  zIndex: 9,
};

const cardStyle = {
  borderRadius: 9,
  backgroundColor: constants.Colors.WARNING,
  borderColor: constants.Colors.WARNING,
  borderWidth: 0,
  borderStyle: 'solid',
  textAlign: 'center',
  paddingLeft: 20,
  paddingRight: 20,
  paddingTop: 15,
  paddingBottom: 15,
};

class FakeReactNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = { navigateTo: '' };
  }

  render() {
    const { history, fieldId, buttonId, onSubmit = () => Promise.resolve() } = this.props;
    return (
      <div style={containerStyle}>
        <div style={cardStyle}>
          <p>This is only shown when running Cypress</p>
          <FieldSimple
            label="Relative path"
            size="medium"
            value={this.state.navigateTo}
            onChange={navigateTo => {
              this.setState({ navigateTo });
            }}
            {...fieldId}
          />
          <SpacerVertical small />
          <ButtonPrimary
            size="medium"
            onClick={() => {
              onSubmit()
                .then(() => {
                  const qp = window.location.href.slice(window.location.href.indexOf('?'));
                  return history.push(`${this.state.navigateTo}${qp}`);
                })
                .catch(() => {
                  history.push(this.state.navigateTo);
                });
            }}
            {...buttonId}
          >
            Go
          </ButtonPrimary>
        </div>
      </div>
    );
  }
}

FakeReactNavigation.propTypes = {
  buttonId: PropTypes.object.required,
  fieldId: PropTypes.object.required,
  history: PropTypes.object,
  onSubmit: PropTypes.func,
};
export default withRouter(FakeReactNavigation);
